import Vue from 'vue'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, min, max, email } from 'vee-validate/dist/rules'

const initValidations = () => {
  extend('required', {
    ...required,
    message: (_, values) => `${values._field_} is required`
  })

  extend('min', {
    ...min,
    message: (_, values) => `Minimum ${values.length} characters`
  })

  extend('max', {
    ...max,
    message: (_, values) => `Maximum ${values.length} characters`
  })

  extend('email', {
    ...email,
    message: (_, values) => `${values._field_} has wrong format`
  })

  extend('url', {
    validate (value) {
      const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/#?[-a-z\\d%_.#:=~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.#~+=-]*)?' + // query string
        '(\\/#[-a-z\\d_#=\\/&]*)?$', 'i') // fragment locator
      return pattern.test(value)
    },
    message: 'Please enter a valid link.'
  })

  extend('fullUrl', {
    validate (value) {
      const pattern = new RegExp('^(https?:\\/\\/)' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/#?[-a-z\\d%_.#:=~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.#~+=-]*)?' + // query string
        '(\\/#[-a-z\\d_#=\\/&]*)?$', 'i') // fragment locator
      return pattern.test(value)
    },
    message: 'Please enter a valid URL.'
  })

  extend('unique', {
    params: ['items', 'field'],
    validate: (value, { items, field = 'name' }) => !items.some(i => i[field] === value),
    message: (_, values) => `Duplicate entry! Please choose a different ${values._field_} and try again.`
  })

  Vue.component('ValidationObserver', ValidationObserver)
  Vue.component('ValidationProvider', ValidationProvider)
}

export { initValidations }
